import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorResponse } from 'src/app/core/models/common.models';
import { IdeadVotesResponse } from 'src/app/core/models/idea.models';
import { IdeasBackendService } from 'src/app/core/services/backend/ideas-backend.service';
import {
  IdeasReqDelVoteAction,
  IdeasReqDelVoteSuccessAction,
  IdeasReqVoteAction,
  IdeasReqVoteErrorAction,
  IdeasReqVoteSuccessAction,
} from 'src/app/core/store/actions/ideas';
import { CoreState } from '../reducers';

@Injectable({
  providedIn: 'root',
})
export class IdeasLikesStoreService {
  constructor(
    private bs: IdeasBackendService, //
    private store$: Store<CoreState>,
  ) {}

  public addVote(ideaId: string): Observable<IdeadVotesResponse> {
    this.store$.dispatch(new IdeasReqVoteAction(ideaId));

    return this.bs.addVote(ideaId).pipe(
      map((res) => {
        this.store$.dispatch(new IdeasReqVoteSuccessAction(res));
        return res;
      }),
      catchError((err: ErrorResponse) => {
        this.store$.dispatch(new IdeasReqVoteErrorAction(err));
        return throwError(() => err);
      }),
    );
  }

  public deleteVote(ideaId: string): Observable<IdeadVotesResponse> {
    this.store$.dispatch(new IdeasReqDelVoteAction(ideaId));

    return this.bs.deleteVote(ideaId).pipe(
      map((res) => {
        this.store$.dispatch(new IdeasReqDelVoteSuccessAction(res));
        return res;
      }),
      catchError((err: ErrorResponse) => {
        this.store$.dispatch(new IdeasReqVoteErrorAction(err));
        return throwError(() => err);
      }),
    );
  }
}
